import React from 'react'
import { inject, observer } from 'mobx-react'
import { ThemeProvider } from 'styled-components'
import { buildTheme, buildGlobalStyle } from '/styles/theme'

const BlankLayout = inject('store')(
  observer(({ siteData, children }) => {
    const theme = buildTheme(siteData)
    const GlobalStyle = buildGlobalStyle(siteData)
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <div>{children}</div>
      </ThemeProvider>
    )
  })
)

export default BlankLayout
